module.exports = __webpack_public_path__ + "img/alipay.27a2b292.svg";